export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";